/* ═══════════════════════════════════════════════════════════
   HALAL KING SUPERMARKET — theme.js  (halal-king-theme-16)
   Changes: paginated product loading, sidebar layout,
            Canned Goods + Rice & Grains category rows,
            improved Best Sellers (8 products)
   ═══════════════════════════════════════════════════════════ */

/* ── SPA page routing ── */
var PAGES = ['home','contact','requests','returns','terms','bulk'];
var activeChip = 'All';

function go(page, anchor) {
  PAGES.forEach(function(p) {
    var el = document.getElementById('page-' + p);
    if (el) el.style.display = p === page ? 'block' : 'none';
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
  if (anchor) {
    setTimeout(function() {
      var t = document.getElementById(anchor);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }
}

function filterCommunity(cat) {
  activeChip = cat;
  currentPage = 1;
  renderProducts(cat, '');
  var sb = document.getElementById('searchBox');
  if (sb) sb.value = '';
  setActiveChip(cat);
  var shopEl = document.getElementById('shop');
  if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ── Cart count ── */
function initCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(c) {
      var el = document.getElementById('cartCount');
      if (el) el.textContent = c.item_count || 0;
    })
    .catch(function() {});
}

/* ── Add to cart ── */
function addToCart(variantId, btn) {
  if (!variantId) return;
  if (btn) { btn.disabled = true; btn.textContent = '…'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    initCart();
    showToast('Added to cart!');
    if (btn) { btn.disabled = false; btn.textContent = '+'; }
  })
  .catch(function() {
    if (btn) { btn.disabled = false; btn.textContent = '+'; }
  });
}

/* ── Toast ── */
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2200);
}

/* ── Product data ── */
var allProducts = [];
var cartQtys = {};
var currentPage = 1;
var filteredForPager = [];

/* ── PAGINATED product loading — loads ALL products ── */
function loadProducts() {
  var collected = [];
  var page = 1;

  function fetchPage() {
    fetch('/products.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var batch = data.products || [];
        collected = collected.concat(batch);
        if (batch.length === 250) {
          page++;
          fetchPage(); // more pages exist
        } else {
          processProducts(collected);
        }
      })
      .catch(function() {
        var g = document.getElementById('productGrid');
        if (g) g.innerHTML = '<div class="no-results">Unable to load products. Please refresh the page.</div>';
      });
  }

  fetchPage();
}

function processProducts(raw) {
  var KNOWN_CATS = ['Halal','Turkish','Hispanic','South Asian','Fruit','Vegetables','Flour & Baking','Dairy','Frozen','Snacks','Beverages','Spices','Bulk','Sauces','Grains & Pulses','Oil','Canned','Bakery','Grocery','Household','Laundry','Personal Care','Feminine Care','Cleaning','Pets','School Supplies','Party','Electrical','Tools'];
  allProducts = raw.map(function(sp) {
    var rawImg = sp.images && sp.images.length > 0 ? sp.images[0].src : null;
    var image  = rawImg ? rawImg.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_400x400$1') : null;
    var tags   = sp.tags || [];
    var price  = sp.variants[0] ? sp.variants[0].price : '0.00';
    var comparePrice = sp.variants[0] ? sp.variants[0].compare_at_price : null;
    var categories = tags.filter(function(tag) { return KNOWN_CATS.includes(tag); });
    if (!categories.length) { var inf = inferCategory(sp.title, tags); categories = inf ? [inf] : ['General']; }
    var category = categories[0];
    var emoji = getEmoji(category, sp.title);
    return {
      id:           sp.id,
      variantId:    sp.variants[0] ? sp.variants[0].id : null,
      name:         sp.title,
      image:        image,
      emoji:        emoji,
      category:     category,
      categories:   categories,
      price:        parseFloat(price),
      comparePrice: comparePrice ? parseFloat(comparePrice) : null,
      description:  sp.body_html ? sp.body_html.replace(/<[^>]+>/g, '') : '',
      tags:         tags,
      isBulk:       tags.includes('Bulk') || tags.includes('bulk') || tags.includes('Bulk Buy & Save') || tags.includes('bulk buy & save'),
      isBestSeller: tags.includes('best seller') || tags.includes('Best Seller') || tags.includes('bestseller') || tags.includes('Bestseller') || tags.includes('Best Sellers'),
      isNew:        tags.includes('new') || tags.includes('New'),
    };
  });

  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    cartQtys = {};
    (c.items||[]).forEach(function(item){cartQtys[item.variant_id]=item.quantity;});
    renderProducts(activeChip, '');
    renderBulk();
    renderBestSellers();
    renderCategoryRow('snacksRow', 'Snacks');
    renderCategoryRow('cannedRow', 'Canned');
    renderCategoryRow('grainsRow', 'Grains & Pulses');
  }).catch(function(){
    renderProducts(activeChip, '');
    renderBulk();
    renderBestSellers();
    renderCategoryRow('snacksRow', 'Snacks');
    renderCategoryRow('cannedRow', 'Canned');
    renderCategoryRow('grainsRow', 'Grains & Pulses');
  });
}

function getEmoji(category, title) {
  var t = (title || '').toLowerCase();
  if (t.includes('chicken'))  return '🍗';
  if (t.includes('beef') || t.includes('lamb') || t.includes('goat')) return '🥩';
  if (t.includes('fish') || t.includes('shrimp')) return '🐟';
  if (t.includes('milk') || t.includes('yogurt') || t.includes('cheese')) return '🥛';
  if (t.includes('bread') || t.includes('roti') || t.includes('naan')) return '🫓';
  if (t.includes('spice') || t.includes('masala')) return '🌶️';
  if (category === 'Turkish')        return '🇹🇷';
  if (category === 'Fruit')          return '🍎';
  if (category === 'Vegetables')     return '🥦';
  if (category === 'Frozen')         return '🧊';
  if (category === 'Snacks')         return '🍿';
  if (category === 'Beverages')      return '🧃';
  if (category === 'Sauces')         return '🍶';
  if (category === 'Grains & Pulses') return '🍚';
  if (category === 'Oil')            return '🫙';
  if (category === 'Canned')         return '🥫';
  if (category === 'Bakery')         return '🥖';
  if (category === 'Flour & Baking') return '🌾';
  if (category === 'Grocery')        return '🛒';
  if (category === 'Household')      return '🏠';
  if (category === 'Laundry')        return '🧺';
  if (category === 'Personal Care')  return '🧴';
  if (category === 'Feminine Care')  return '🌸';
  if (category === 'Cleaning')       return '🧹';
  if (category === 'Pets')           return '🐾';
  if (category === 'School Supplies') return '📚';
  if (category === 'Party')          return '🎉';
  if (category === 'Electrical')     return '🔌';
  if (category === 'Tools')          return '🔧';
  return '🛒';
}

function inferCategory(title, tags) {
  var t = (title || '').toLowerCase();
  if (t.includes('flour') || t.includes('corn meal') || t.includes('cornmeal') || t.includes('masarepa') || t.includes('masa harina') || t.includes('tapioca') || t.includes('yuca harina') || t.includes('starch') || t.includes('baking powder') || t.includes('baking soda') || t.includes('cake mix') || t.includes('pancake mix') || t.includes('waffle mix') || t.includes('bread mix') || t.includes('baking mix') || t.includes('cream caramel')) return 'Flour & Baking';
  if (t.includes('pasta') || t.includes('noodle') || t.includes('spaghetti') || t.includes('macaroni') || t.includes('vermicelli')) return 'Grains & Pulses';
  if (t.includes('basmati') || (t.includes('rice') && !t.includes('sauce') && !t.includes('rice cake') && !t.includes('rice flour'))) return 'Grains & Pulses';
  if (t.includes('lentil') || t.includes('daal') || t.includes('dhal') || t.includes('dal ') || t.includes(' dal') || t.includes('chana') || t.includes('moong') || t.includes('masoor') || t.includes('toor') || t.includes('urad')) return 'Grains & Pulses';
  if (t.includes('bulgur') || t.includes('quinoa') || t.includes('couscous') || t.includes('barley') || t.includes('oat') || t.includes('semolina') || t.includes('atta')) return 'Grains & Pulses';
  if (t.includes('apple') || t.includes('mango') || t.includes('banana') || t.includes('orange') || t.includes('grape') || t.includes('berry') || t.includes('peach') || t.includes('pear') || t.includes('melon') || t.includes('watermelon') || t.includes('pineapple') || t.includes('strawberry') || t.includes('blueberry') || t.includes('cherry') || t.includes('plum') || t.includes('kiwi') || t.includes('lemon') || t.includes('lime') || t.includes('pomegranate') || t.includes('guava') || t.includes('papaya') || t.includes('lychee') || t.includes('date fruit') || t.includes('apricot') || t.includes('fig')) return 'Fruit';
  if (t.includes('carrot') || t.includes('onion') || t.includes('garlic') || t.includes('ginger') || t.includes('potato') || t.includes('tomato') || t.includes('pepper') || t.includes('capsicum') || t.includes('cucumber') || t.includes('spinach') || t.includes('cabbage') || t.includes('broccoli') || t.includes('cauliflower') || t.includes('zucchini') || t.includes('eggplant') || t.includes('aubergine') || t.includes('okra') || t.includes('bitter gourd') || t.includes('bitter melon') || t.includes('pumpkin') || t.includes('squash') || t.includes('celery') || t.includes('lettuce') || t.includes('kale') || t.includes('arugula') || t.includes('leek') || t.includes('turnip') || t.includes('radish') || t.includes('beetroot') || (t.includes('corn') && !t.includes('meal') && !t.includes('flour') && !t.includes('starch') && !t.includes('oil')) || t.includes('pea ') || t.includes('green bean') || t.includes('asparagus') || t.includes('artichoke')) return 'Vegetables';
  if (t.includes('cooking oil') || t.includes('olive oil') || t.includes('vegetable oil') || t.includes('sunflower oil') || t.includes('canola oil') || t.includes('palm oil') || t.includes('coconut oil') || t.includes('sesame oil') || t.includes('mustard oil') || t.includes('corn oil') || t.includes('ghee') || t.includes('shortening')) return 'Oil';
  if (t.includes('sauce') || t.includes('ketchup') || t.includes('mayo') || t.includes('mustard') || t.includes('vinegar') || t.includes('salsa') || t.includes('hot sauce') || t.includes('soy sauce') || t.includes('chili sauce') || t.includes('garlic sauce') || t.includes('tahini') || t.includes('hummus')) return 'Sauces';
  if (t.includes('detergent') || t.includes('laundry') || t.includes('fabric softener') || t.includes('tide') || t.includes('washing powder') || t.includes('dryer sheet') || t.includes('stain remover')) return 'Laundry';
  if (t.includes('shampoo') || t.includes('conditioner') || t.includes('toothpaste') || t.includes('lotion') || t.includes('deodorant') || t.includes('body wash') || t.includes('hand soap') || t.includes('moisturizer') || t.includes('face wash') || t.includes('sunscreen') || t.includes('cotton swab') || t.includes('razor') || t.includes('shaving')) return 'Personal Care';
  if (t.includes('pad ') || t.includes(' pad') || t.includes('tampon') || t.includes('feminine') || t.includes('menstrual') || t.includes('panty liner') || t.includes('always') || t.includes('kotex')) return 'Feminine Care';
  if (t.includes('bleach') || t.includes('floor cleaner') || t.includes('disinfect') || t.includes('mop') || t.includes('sponge') || t.includes('glass cleaner') || t.includes('all-purpose cleaner') || t.includes('bathroom cleaner') || t.includes('dish soap') || t.includes('dishwasher')) return 'Cleaning';
  if (t.includes('canned') || t.includes('tin ') || t.includes(' can ') || t.includes('chickpea') || t.includes('kidney bean') || t.includes('tomato paste') || t.includes('sardine') || t.includes('tuna can') || t.includes('coconut milk')) return 'Canned';
  if (t.includes('bread') || t.includes('cake') || t.includes('cookie') || t.includes('biscuit') || t.includes('muffin') || t.includes('croissant') || t.includes('bagel') || t.includes('pita') || t.includes('roti') || t.includes('naan') || t.includes('paratha') || t.includes('tortilla') || t.includes('flatbread') || t.includes('sourdough')) return 'Bakery';
  if (t.includes('dog food') || t.includes('cat food') || t.includes('pet food') || t.includes('kibble') || t.includes('cat litter') || t.includes('dog treat') || t.includes('cat treat') || t.includes('pet ') || t.includes(' pet') || t.includes('aquarium') || t.includes('bird seed') || t.includes('hamster')) return 'Pets';
  if (t.includes('notebook') || t.includes('pencil') || t.includes('pen ') || t.includes(' pen') || t.includes('backpack') || t.includes('ruler') || t.includes('eraser') || t.includes('marker') || t.includes('highlighter') || t.includes('stapler') || t.includes('scissors') || t.includes('glue stick') || t.includes('folder') || t.includes('binder') || t.includes('crayon') || t.includes('school supply')) return 'School Supplies';
  if (t.includes('balloon') || t.includes('decoration') || t.includes('party plate') || t.includes('party cup') || t.includes('party napkin') || t.includes('streamer') || t.includes('confetti') || t.includes('party supply') || t.includes('birthday candle') || t.includes('gift bag') || t.includes('party pack')) return 'Party';
  if (t.includes('light bulb') || t.includes('battery') || t.includes('extension cord') || t.includes('adapter') || t.includes('charger') || t.includes('cable') || t.includes('plug') || t.includes('switch') || t.includes('socket') || t.includes('led ')) return 'Electrical';
  if (t.includes('toilet paper') || t.includes('paper towel') || t.includes('garbage bag') || t.includes('storage bag') || t.includes('trash bag') || t.includes('aluminum foil') || t.includes('cling wrap') || t.includes('plastic wrap') || t.includes('ziplock') || t.includes('food container') || t.includes('kitchen roll')) return 'Household';
  if (t.includes('tape') || t.includes('hammer') || t.includes('screw') || t.includes('nail') || t.includes('tool') || t.includes('drill bit') || t.includes('wrench') || t.includes('plier')) return 'Tools';
  if (t.includes('turkish') || t.includes('baklava') || t.includes('sumac') || t.includes('isot') || t.includes('dolma') || t.includes('sucuk') || t.includes('kashar') || t.includes('halva') || t.includes('ayran') || t.includes('boza')) return 'Turkish';
  return null;
}

/* ── Chip filters (sidebar) ── */
var ALL_CHIPS = ['All','On Sale','Bulk Buy & Save','Halal','Turkish','Hispanic','South Asian','Fruit','Vegetables','Flour & Baking','Dairy','Frozen','Snacks','Beverages','Spices','Sauces','Grains & Pulses','Oil','Canned','Bakery','Grocery','Household','Laundry','Personal Care','Feminine Care','Cleaning','Pets','School Supplies','Party','Electrical','Tools'];

function renderChips() {
  var row = document.getElementById('chipRow');
  if (!row) return;
  var saleCount = allProducts.filter(function(p) { return !p.isBulk && p.comparePrice && p.comparePrice > p.price; }).length;
  var bulkCount = allProducts.filter(function(p) { return p.isBulk; }).length;
  row.innerHTML = ALL_CHIPS.map(function(c) {
    var extra = '';
    var label = c;
    if (c === 'On Sale') {
      extra = ' sale-chip';
      label = '🏷️ On Sale' + (saleCount > 0 ? ' <span class="sale-chip-count">' + saleCount + '</span>' : '');
    } else if (c === 'Bulk Buy & Save') {
      extra = ' bulk-chip';
      label = '📦 Bulk Buy &amp; Save' + (bulkCount > 0 ? ' <span class="bulk-chip-count">' + bulkCount + '</span>' : '');
    }
    return '<button class="chip' + (c === activeChip ? ' active' : '') + extra + '" data-cat="' + c + '" onclick="chipClick(this,\'' + c.replace(/'/g,"\\'")+'\')">' + label + '</button>';
  }).join('');
}

function chipClick(btn, cat) {
  activeChip = cat;
  currentPage = 1;
  setActiveChip(cat);
  renderProducts(cat, document.getElementById('searchBox') ? document.getElementById('searchBox').value : '');
}

function setActiveChip(cat) {
  document.querySelectorAll('.chip').forEach(function(c) {
    c.classList.toggle('active', c.dataset.cat === cat);
  });
}

/* ── Render products (with pagination) ── */
var PAGE_SIZE = 50;

function renderProducts(filter, search) {
  var grid = document.getElementById('productGrid');
  if (!grid) return;
  var q = (search || '').toLowerCase();
  var isBulkFilter = (filter === 'Bulk Buy & Save');
  var list = allProducts.filter(function(p) {
    if (isBulkFilter) {
      if (!p.isBulk) return false;
    } else {
      if (p.isBulk) return false;
    }
    var matchCat;
    if (isBulkFilter) {
      matchCat = true;
    } else if (!filter || filter === 'All') {
      matchCat = true;
    } else if (filter === 'On Sale') {
      matchCat = !!(p.comparePrice && p.comparePrice > p.price) || p.tags.includes('On Sale') || p.tags.includes('sale');
    } else {
      matchCat = p.categories.includes(filter);
    }
    var matchSearch = !q || p.name.toLowerCase().includes(q) || p.categories.join(' ').toLowerCase().includes(q);
    return matchCat && matchSearch;
  });
  filteredForPager = list;
  var totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
  if (currentPage > totalPages) currentPage = totalPages;
  var start = (currentPage - 1) * PAGE_SIZE;
  var pageItems = list.slice(start, start + PAGE_SIZE);
  if (!list.length) {
    grid.innerHTML = '<div class="no-results">No products found — try a different search or category.</div>';
    var pager = document.getElementById('productPager');
    if (pager) pager.innerHTML = '';
    return;
  }
  grid.innerHTML = pageItems.map(function(p) { return productCard(p, isBulkFilter); }).join('');
  var pager = document.getElementById('productPager');
  if (pager) {
    if (totalPages <= 1) {
      pager.innerHTML = '';
    } else {
      var html = '<div class="pager">';
      html += '<button class="pager-btn" onclick="goPage(-1)"' + (currentPage <= 1 ? ' disabled' : '') + '>← Prev</button>';
      html += '<span class="pager-info">Page ' + currentPage + ' of ' + totalPages + ' &nbsp;·&nbsp; ' + list.length + ' products</span>';
      html += '<button class="pager-btn" onclick="goPage(1)"' + (currentPage >= totalPages ? ' disabled' : '') + '>Next →</button>';
      html += '</div>';
      pager.innerHTML = html;
    }
  }
}

function goPage(dir) {
  var totalPages = Math.max(1, Math.ceil(filteredForPager.length / PAGE_SIZE));
  currentPage = Math.max(1, Math.min(totalPages, currentPage + dir));
  var grid = document.getElementById('productGrid');
  if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  renderProducts(activeChip, document.getElementById('searchBox') ? document.getElementById('searchBox').value : '');
}

function productCard(p, isBulkMode) {
  var onSale     = p.comparePrice && p.comparePrice > p.price;
  var saleBadge  = onSale ? '<span class="sale-badge">Sale</span>' : '';
  var newBadge   = p.isNew ? '<span class="new-badge">New In</span>' : '';
  var bulkBadge  = p.isBulk ? '<span class="bulk-badge">BULK</span>' : '';
  var thumb = p.image
    ? '<div class="p-img-box' + (p.isBulk ? ' bulk-img-frame' : '') + '">' + saleBadge + newBadge + bulkBadge + '<img src="' + p.image + '" alt="' + p.name + '" loading="lazy"></div>'
    : '<div class="p-emoji' + (p.isBulk ? ' bulk-emoji-frame' : '') + '">' + saleBadge + newBadge + bulkBadge + p.emoji + '</div>';
  var priceHtml = onSale
    ? '<span class="p-was">$' + p.comparePrice.toFixed(2) + '</span><span class="p-price on-sale">$' + p.price.toFixed(2) + '</span>'
    : '<span class="p-price' + (p.isBulk ? ' bulk-price-color' : '') + '">$' + p.price.toFixed(2) + '</span>';
  var qty = cartQtys[p.variantId] || 0;
  var addCtrl = qty > 0
    ? '<div class="qty-mini"><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',-1)">−</button><span>' + qty + '</span><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',1)">+</button></div>'
    : '<button class="add-btn' + (p.isBulk ? ' bulk-add-btn' : '') + '" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>';
  return '<div class="product' + (p.isBulk ? ' product-bulk' : '') + '" onclick="openProduct(' + p.id + ')">' + thumb + '<div class="p-cat">' + (p.isBulk ? 'Bulk Buy &amp; Save' : p.category) + '</div>' + '<div class="p-name">' + p.name + '</div>' + (onSale && p.isBulk ? '<div style="font-size:.76rem;color:#0f9d8f;font-weight:700;margin-top:.2rem">Save $' + (p.comparePrice - p.price).toFixed(2) + '</div>' : '') + '<div class="p-foot">' + priceHtml + addCtrl + '</div>' + '</div>';
}

function changeQty(variantId, delta) {
  var current = cartQtys[variantId] || 0;
  var newQty = Math.max(0, current + delta);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: newQty }),
  }).then(function(r){return r.json();}).then(function(c){
    cartQtys = {};
    (c.items||[]).forEach(function(item){cartQtys[item.variant_id]=item.quantity;});
    var el = document.getElementById('cartCount');
    if (el) el.textContent = c.item_count || 0;
    renderProducts(activeChip, document.getElementById('searchBox') ? document.getElementById('searchBox').value : '');
  }).catch(function(){});
}

/* ── Render bulk ── */
function renderBulk() {
  var grids = [document.getElementById('bulkGrid'), document.getElementById('bulkGridPage')];
  var bulkItems = allProducts.filter(function(p) { return p.isBulk; });
  grids.forEach(function(grid) {
    if (!grid) return;
    if (!bulkItems.length) { grid.innerHTML = '<div class="no-results">No bulk items available right now.</div>'; return; }
    grid.innerHTML = bulkItems.map(function(p) {
      var thumb = p.image ? '<div class="bulk-img-box"><img src="' + p.image + '" alt="' + p.name + '" loading="lazy"></div>' : '<div class="bulk-emoji">' + p.emoji + '</div>';
      var onSale = p.comparePrice && p.comparePrice > p.price;
      return '<div class="bulk-card" onclick="openProduct(' + p.id + ')">' + '<span class="bulk-tag">BULK</span>' + thumb + '<div class="bulk-name">' + p.name + '</div>' + (onSale ? '<div class="bulk-save-note">Save $' + (p.comparePrice - p.price).toFixed(2) + ' vs. regular price</div>' : '') + '<div class="bulk-foot"><span class="bulk-price">$' + p.price.toFixed(2) + '</span>' + '<button class="add-btn" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>' + '</div></div>';
    }).join('');
  });
}

/* ── Category row arrow scroll ── */
function scrollCatRow(rowId, dir) {
  var row = document.getElementById(rowId);
  if (!row) return;
  var amount = row.clientWidth * 0.8;
  row.scrollBy({ left: dir * amount, behavior: 'smooth' });
}

/* ── Category rows (Snacks + Canned Goods + Rice & Grains) ── */
function renderCategoryRow(rowId, catFilter) {
  var row = document.getElementById(rowId);
  if (!row) return;
  var items = allProducts.filter(function(p) {
    return !p.isBulk && p.categories.includes(catFilter);
  }).slice(0, 24);
  if (!items.length) {
    var section = row.closest('.cat-row-section');
    if (section) section.style.display = 'none';
    return;
  }
  row.innerHTML = items.map(function(p) {
    var onSale = p.comparePrice && p.comparePrice > p.price;
    var thumb = p.image ? '<img class="cat-item-img" src="' + p.image + '" alt="' + p.name + '" loading="lazy">' : '<div class="cat-item-emoji">' + p.emoji + '</div>';
    var priceHtml = onSale ? '<span style="text-decoration:line-through;color:#999;font-size:.78rem">$' + p.comparePrice.toFixed(2) + '</span> <span class="cat-item-price on-sale">$' + p.price.toFixed(2) + '</span>' : '<span class="cat-item-price">$' + p.price.toFixed(2) + '</span>';
    var qty = cartQtys[p.variantId] || 0;
    var addCtrl = qty > 0 ? '<div class="qty-mini" style="justify-content:center"><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',-1)">−</button><span>' + qty + '</span><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',1)">+</button></div>' : '<button class="add-btn" style="margin:0 auto;display:flex" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>';
    return '<div class="cat-item" onclick="openProduct(' + p.id + ')">' + thumb + '<div class="cat-item-name">' + p.name + '</div>' + '<div class="cat-item-foot">' + priceHtml + addCtrl + '</div>' + '</div>';
  }).join('');
}

/* ── Product detail modal ── */
function openProduct(id) {
  var p = allProducts.find(function(x) { return x.id === id; });
  if (!p) return;
  document.getElementById('pdTitle').textContent = p.name;
  var onSale = p.comparePrice && p.comparePrice > p.price;
  var saleBadge = onSale ? '<span class="sale-badge" style="position:relative;top:0;left:0;display:inline-block;margin-bottom:.5rem">Sale</span>' : '';
  var newBadge  = p.isNew ? '<span class="new-badge" style="position:relative;top:0;right:0;display:inline-block;margin-bottom:.5rem;margin-left:.4rem">New In</span>' : '';
  var pdMedia = p.image ? '<div class="pd-img-box">' + saleBadge + newBadge + '<img src="' + p.image + '" alt="' + p.name + '"></div>' : '<div class="pd-emoji-box">' + saleBadge + newBadge + p.emoji + '</div>';
  var priceRow = onSale ? '<span class="pd-price-now on-sale">$' + p.price.toFixed(2) + '</span><span class="pd-price-was">$' + p.comparePrice.toFixed(2) + '</span><span class="pd-save-badge">Save $' + (p.comparePrice - p.price).toFixed(2) + '</span>' : '<span class="pd-price-now">$' + p.price.toFixed(2) + '</span>';
  var desc = p.description ? '<div class="pd-section"><div class="pd-section-lbl">Description</div><p>' + p.description.substring(0, 300) + '</p></div>' : '';
  document.getElementById('pdBody').innerHTML = pdMedia + '<div class="pd-cat">' + p.category + '</div>' + '<div class="pd-name">' + p.name + '</div>' + '<div class="pd-price-row">' + priceRow + '</div>' + desc + '<button class="pd-add-btn" onclick="addToCart(' + p.variantId + ',this)">Add to Cart →</button>';
  document.getElementById('pdModal').classList.add('show');
  document.body.style.overflow = 'hidden';
}

function closePd() {
  document.getElementById('pdModal').classList.remove('show');
  document.body.style.overflow = '';
}

/* ── Carousel ── */
var slideIndex = 0;
var slideTimer;

function startCarousel() {
  var slides = document.querySelectorAll('.slide');
  var dots   = document.getElementById('carDots');
  if (!slides.length) return;
  if (dots) {
    dots.innerHTML = Array.from(slides).map(function(_, i) {
      return '<button class="' + (i === 0 ? 'active' : '') + '" onclick="goSlide(' + i + ')" aria-label="Slide ' + (i+1) + '"></button>';
    }).join('');
  }
  slideTimer = setInterval(function() { moveSlide(1); }, 5000);
}

function goSlide(n) {
  clearInterval(slideTimer);
  slideIndex = n;
  updateSlide();
  slideTimer = setInterval(function() { moveSlide(1); }, 5000);
}

function moveSlide(dir) {
  var slides = document.querySelectorAll('.slide');
  slideIndex = (slideIndex + dir + slides.length) % slides.length;
  updateSlide();
}

function updateSlide() {
  var slides = document.querySelectorAll('.slide');
  var dotBtns = document.querySelectorAll('#carDots button');
  slides.forEach(function(s, i) { s.classList.toggle('active', i === slideIndex); });
  dotBtns.forEach(function(d, i) { d.classList.toggle('active', i === slideIndex); });
}

/* ── Reviews ── */
var staticReviews = [
  { name: 'Fatima A.', stars: 5, text: 'Best halal grocery store in the area! The meat is always fresh and the staff are so friendly.' },
  { name: 'Carlos M.', stars: 5, text: 'Love that they carry Goya and all my favorite Hispanic products. Online ordering is super easy.' },
  { name: 'Priya S.', stars: 5, text: 'Finally a place that has all my South Asian spices and Amul products. Delivery was fast!' },
  { name: 'Ahmed K.', stars: 5, text: 'The quality of the zabiha halal chicken is unmatched. I order every week now.' },
];

function renderReviews() {
  var list = document.getElementById('reviewsList');
  if (!list) return;
  list.innerHTML = staticReviews.map(function(r) {
    return '<div class="review-card">'
      + '<div class="review-top"><span class="review-name">' + r.name + '</span>'
      + '<span class="review-stars">' + '★'.repeat(r.stars) + '</span></div>'
      + '<div class="review-text">' + r.text + '</div>'
      + '</div>';
  }).join('');
}

/* ── Star picker ── */
var selectedStars = 0;

function initStarPicker() {
  var picker = document.getElementById('starPicker');
  if (!picker) return;
  picker.querySelectorAll('button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      selectedStars = parseInt(btn.dataset.s);
      picker.querySelectorAll('button').forEach(function(b, i) {
        b.classList.toggle('on', i < selectedStars);
      });
    });
  });
}

function submitReview() {
  var hint = document.getElementById('starHint');
  if (!selectedStars) { if (hint) hint.style.display = 'block'; return; }
  if (hint) hint.style.display = 'none';
  var name = (document.getElementById('rName') || {}).value || 'Anonymous';
  var text = (document.getElementById('rText') || {}).value || '';
  if (!text) return;
  staticReviews.unshift({ name: name, stars: selectedStars, text: text });
  renderReviews();
  var reward = document.getElementById('rewardBox');
  if (reward) reward.style.display = 'block';
  var rName = document.getElementById('rName'); if (rName) rName.value = '';
  var rText = document.getElementById('rText'); if (rText) rText.value = '';
  selectedStars = 0;
  var picker = document.getElementById('starPicker');
  if (picker) picker.querySelectorAll('button').forEach(function(b){b.classList.remove('on');});
}

/* ── Best Sellers row (improved: 8 products across categories) ── */
function renderBestSellers() {
  var row = document.getElementById('bestSellersRow');
  var wrap = document.getElementById('bestSellersWrap');
  if (!row) return;

  // Start with products explicitly tagged as Best Sellers
  var tagged = allProducts.filter(function(p) { return p.isBestSeller && !p.isBulk; });
  var items = tagged.slice();
  var usedIds = {};
  items.forEach(function(p) { usedIds[p.id] = true; });

  // Supplement up to 8 with one good product per key category (prefer products with images)
  var keyCats = ['Beverages','Grains & Pulses','Canned','Snacks','Sauces','Halal','Hispanic','South Asian','Dairy','Bakery','Frozen','Oil'];
  for (var i = 0; i < keyCats.length && items.length < 8; i++) {
    var cat = keyCats[i];
    var candidates = allProducts.filter(function(p) {
      return !p.isBulk && !usedIds[p.id] && p.categories.includes(cat) && p.image;
    });
    if (!candidates.length) {
      candidates = allProducts.filter(function(p) {
        return !p.isBulk && !usedIds[p.id] && p.categories.includes(cat);
      });
    }
    if (candidates.length) {
      items.push(candidates[0]);
      usedIds[candidates[0].id] = true;
    }
  }

  items = items.slice(0, 8);

  if (!items.length) {
    if (wrap) wrap.style.display = 'none';
    return;
  }
  if (wrap) wrap.style.display = '';
  row.innerHTML = items.map(function(p) {
    var onSale = p.comparePrice && p.comparePrice > p.price;
    var thumb = p.image ? '<div class="bs-img-box"><img src="' + p.image + '" alt="' + p.name + '" loading="lazy"></div>' : '<div class="bs-emoji">' + p.emoji + '</div>';
    var priceHtml = onSale ? '<span class="p-was">$' + p.comparePrice.toFixed(2) + '</span><span class="p-price on-sale">$' + p.price.toFixed(2) + '</span>' : '<span class="p-price">$' + p.price.toFixed(2) + '</span>';
    var qty = cartQtys[p.variantId] || 0;
    var addCtrl = qty > 0 ? '<div class="qty-mini"><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',-1)">−</button><span>' + qty + '</span><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',1)">+</button></div>' : '<button class="add-btn" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>';
    return '<div class="bs-card" onclick="openProduct(' + p.id + ')">' + '<span class="bs-star-badge">⭐ Best Seller</span>' + thumb + '<div class="bs-name">' + p.name + '</div>' + '<div class="bs-foot">' + priceHtml + addCtrl + '</div>' + '</div>';
  }).join('');
}

/* ── Contact form ── */
function submitContact() {
  var ok = document.getElementById('contactOk');
  if (ok) { ok.style.display = 'block'; }
  ['cName','cPhone','cMsg'].forEach(function(id) { var el = document.getElementById(id); if (el) el.value=''; });
}

/* ── Product request form ── */
function submitRequest() {
  var ok = document.getElementById('requestOk');
  if (ok) { ok.style.display = 'block'; }
  ['rqProduct','rqBrand','rqName','rqContact'].forEach(function(id) { var el = document.getElementById(id); if (el) el.value=''; });
}

/* ══════════════════════════════════
   INIT
══════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function() {
  initCart();
  loadProducts();
  renderChips();
  renderReviews();
  initStarPicker();
  startCarousel();

  var hash = location.hash.replace('#','');
  if (hash && PAGES.includes(hash)) go(hash);

  window.addEventListener('hashchange', function() {
    var h = location.hash.replace('#','');
    if (h && PAGES.includes(h)) go(h);
  });
});